var BaseViews = require('../../base');
require('./product-zoomer/product-zoomer.scss');
var ProductZoomer = BaseViews.LayoutView.extend({
    _leafletMap: null,
    className: 'fmcy-product-zoomer fmcy-product-zoomer',
    template: require('./product-zoomer/product-zoomer.html'),
    ui: {
        leafletMapTarget: '.fmcy-leaflet-map-target'
    },
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light'
            }
        );
        this.model.on('change:zoomEnabled', function() {
            self.toggleMapControls();
        });

        this.model.on('change:imageSize', function() {
            self.toggleImageSize();
        });
    },
    toggleImageSize: function() {
        var imageSize = this.model.get('imageSize');
        var imageObj = this.options.getImageBySize(imageSize);

        // kind of a magic number...
        var zoomBuffer = 2;
        switch (imageSize) {
            case 'xlarge':
                zoomBuffer = 3;
                break;
            case 'large':
                zoomBuffer = 3;
                break;
            default:
                zoomBuffer = 2;
                break;
        }

        // dimensions of the image

        var w = imageObj.w * zoomBuffer,
            h = imageObj.h * zoomBuffer,
            url = imageObj.url;

        // calculate the edges of the image, in coordinate space
        var southWest = this._leafletMap.unproject([0, h], this._leafletMap.getMaxZoom() + 1);
        var northEast = this._leafletMap.unproject([w, 0], this._leafletMap.getMaxZoom() + 1);

        var bounds = new L.LatLngBounds(southWest, northEast);

        if (this.imageOverlay) {
            this.imageOverlay.removeFrom(this._leafletMap);
        }

        // add the image overlay,
        this.imageOverlay = L.imageOverlay(url, bounds).addTo(this._leafletMap);

        // so that it covers the entire map
        this._leafletMap.fitBounds(bounds);

        switch (imageSize) {
            case 'xlarge':
                this._leafletMap.options.minZoom = 5;
                this._leafletMap.options.maxZoom = 9;
                this._leafletMap.setZoom(7);
                break;
            case 'large':
                this._leafletMap.options.minZoom = 5;
                this._leafletMap.options.maxZoom = 10;
                this._leafletMap.setZoom(7);
                break;
            default:
                this._leafletMap.options.minZoom = 5;
                this._leafletMap.options.maxZoom = 10;
                this._leafletMap.setZoom(7);
                break;
        }
    },
    toggleMapControls: function() {
        if (this.model.get('zoomEnabled')) {
            this._leafletMap.dragging.enable();
            if (this._leafletMap.tap) {
                this._leafletMap.tap.enable();
            }
            this._leafletMap.touchZoom.enable();
            this._leafletMap.doubleClickZoom.enable();
        } else {
            this._leafletMap.dragging.disable();
            this._leafletMap.touchZoom.disable();
            this._leafletMap.doubleClickZoom.disable();
            this._leafletMap.scrollWheelZoom.disable();
            if (this._leafletMap.tap) {
                this._leafletMap.tap.disable();
            }
        }
    },
    onShow: function() {
        var self = this;
        if (this.options.theme === 'dark') {
          this.$el.addClass('fmcy-product-zoomer-theme-dark');
        }
        this._leafletMap = L.map(this.ui.leafletMapTarget[0], {
            zoomControl: true,
            scrollWheelZoom: true,
            minZoom: 7,
            maxZoom: 9,
            center: [0, 0],
            zoom: 7,
            tap: false,
            crs: L.CRS.Simple
        });

        this.toggleImageSize();
        this.toggleMapControls();

        if (this._leafletMap) {
            this._leafletMap._onResize();
        }

        this._onWindowResize();

        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
    },
    _onWindowResize: function (event) {

      this.ui.leafletMapTarget.height($(window).height());
      this.ui.leafletMapTarget.width($(window).width());

      if (this._leafletMap) {
          this._leafletMap._onResize();
      }

    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
    }
});

module.exports = ProductZoomer;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-item-expanded/product-zoomer.js
 **/